import WalletsUpgradeCompletedModal from './wallets-upgrade-completed-modal';

export default WalletsUpgradeCompletedModal;
